/*
 * @Author: 曹捷
 * @Date: 2021-10-11 15:55:54
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-10-11 15:55:54
 * @Description: fileContent
 */

export const baseUrl = process.env.VUE_APP_BASE_URL